module.exports = __webpack_public_path__ + "img/online-learning.a8f9a9a0.svg";